import { throwOnError } from './utils';

type FetchTransfersCSVResponse = {
  url: string;
};

// eslint-disable-next-line import/prefer-default-export
export const fetchTransfersCSV = (query = '') =>
  fetch(`/api/transfers/csv?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<FetchTransfersCSVResponse>);
